module.exports = __webpack_public_path__ + "img/butter_chicken_marinade.78291c6f.jpg";